<h2 class="heading-4 mb-16">
  {{ stepTitle[vm.activeStep?.name] ?? stepTitle[vm.currentStep] ?? vm.activeStep?.title }}
</h2>

<form (formValueChange)="formValue.set($event)" (submit)="submitFormValue()">
  @for (step of [vm.activeStep]; track step?.name) {
    @if (vm.currentStep === 'claim-type') {
      <app-claim-type-selection
        ngModelGroup="claim-type"
        [claimTypes]="[]"
        [formValue]="vm.formValue['claim-type']"
        [submittingValue]="vm.submittingValue"
        [formSubmitted]="vm.stageSubmitted"
        (formValid)="setFormValidStatus($event)"
      />
    } @else if (vm.activeStep?.name === 'item_product') {
      <app-model-number-capture
        [ngModelGroup]="vm.currentStep"
        [submittingValue]="vm.submittingValue"
        [formValue]="vm.formValue[vm.currentStep]"
        [formSubmitted]="vm.stageSubmitted"
        [activeStep]="vm.activeStep"
        [productDescription]="vm.productDescription"
        (loadingData)="loadingData.set($event)"
        (formValid)="setFormValidStatus($event)"
      />
    } @else if (vm.currentStep === 'contact_details') {
      <app-contact-details
        [ngModelGroup]="vm.currentStep"
        [submittingValue]="vm.submittingValue"
        [formValue]="vm.formValue[vm.currentStep]"
        [formSubmitted]="vm.stageSubmitted"
        [stepConfig]="vm.stepConfig"
        (formValid)="setFormValidStatus($event)"
      />
    } @else if (vm.currentStep === 'service_options') {
      <app-service-options
        [ngModelGroup]="vm.currentStep"
        [formValue]="vm.formValue[vm.currentStep]"
        [submittingValue]="vm.submittingValue"
        [formSubmitted]="vm.stageSubmitted"
        [activeStep]="vm.activeStep"
        (formValid)="setFormValidStatus($event)"
        (loadingData)="loadingData.set($event)"
      />
    } @else if (vm.currentStep === 'initial_visit_appointment') {
      <app-visit-appointment
        [ngModelGroup]="vm.currentStep"
        [formValue]="vm.formValue[vm.currentStep]"
        [submittingValue]="vm.submittingValue"
        [formSubmitted]="vm.stageSubmitted"
        [activeStep]="vm.activeStep"
        [stepConfig]="vm.stepConfig"
        (formValid)="setFormValidStatus($event)"
        (loadingData)="loadingData.set($event)"
      />
    } @else {
      <app-generic-form-handler
        [ngModelGroup]="vm.currentStep"
        [currentStep]="vm.currentStep"
        [formValue]="vm.formValue[vm.currentStep]"
        [submittingValue]="vm.submittingValue"
        [formSubmitted]="vm.stageSubmitted"
        [activeStep]="vm.activeStep"
        (formValid)="setFormValidStatus($event)"
        (loadingData)="loadingData.set($event)"
      />
    }
  }

  <section class="actions mt-16 flex gap-8 full-width">
    <app-button
      dataLabel="continue-button"
      [buttonOptions]="{
        type: 'submit',
        disabled: vm.loadingData,
      }"
      [loading]="vm.submittingValue"
      class="min-w-160"
    >
      {{ buttonTitle[vm.currentStep] || 'Continue' }}
      <i class="fa-light fa-arrow-right ml-8"></i>
    </app-button>

    @if (vm.currentStep !== 'visit_appointment') {
      <app-button
        dataLabel="back-button"
        class="min-w-160"
        [buttonOptions]="{
          variant: 'secondary',
        }"
        (click)="goBack()"
      >
        <i class="fa-light fa-arrow-left mr-8"></i>
        Back
      </app-button>
    }
  </section>
</form>
